import { nanoid } from '@ant-design/pro-components';
import { Typography, Tabs, TabsProps } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// icons
import PageWrapper from 'pages/Components/PageWrapper';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import AddCustomerSegment from './addCustomerSegment';
import CustomerSegmentDetail from './detailCustomerSegment';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import createCustomerSegmentation from '..';

const { Text } = Typography;

export type TargetKey = React.MouseEvent | React.KeyboardEvent | string;

const createDetailCustomerSegment = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.customer-seg') + ' - ' + SYSTEM_TITLE;

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // lấy id của tab (nếu như có id là tab xem chi tiết)
    const tabId = searchParams.get('tabId');
    const changeTab = searchParams.get('changeTab');

    // ==================================== STATE ===================================================
    // const [idTabDetail, setIdtabDetail] = useState(() => {
    //   if (tabId && typeTab === 'detail') return tabId;
    //   return undefined;
    // });

    const [deleteKey, setDeleteKey] = useState('');

    const CustomerSegmentation = createCustomerSegmentation();
    // ============================================ XỬ LÝ TABS =========================================

    const [activeKey, setActiveKey] = useState('1');
    const [items, setItems] = useState<TabsProps['items']>([
      {
        label: t('segment.danh-sach'),
        key: '1',
        closable: false,
        children: <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm">
          <CustomerSegmentation />
        </div>,
      },
    ]);

    const onChange = (newActiveKey: string) => {
      // if (newActiveKey === '1') {
      //   navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.LINK);
      // } else {
      navigate(
        ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK +
        `?tabId=${newActiveKey}&changeTab=true`,
      );
      // }
      setActiveKey(newActiveKey);
    };
    const addNewTab = (newActiveKey: string) => {
      if (items) {

        const newPanes = [...items];
        newPanes.push({
          label: t('btn.create'),
          children: <AddCustomerSegment tabID={newActiveKey as string} onMoveTab={removeKey} />,
          key: newActiveKey,
        });
        setItems(newPanes);
        setActiveKey(newActiveKey);
        // navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK + `?tabId=${newActiveKey}`);
      }
    };
    const addTabDetail = async () => {
      if (items && tabId) {
        const newKey = tabId as string;
        const newPanes = [...items];
        const hasDetail = newPanes.find((i) => i.key === tabId);

        if (!hasDetail) {
          const id = tabId.replace('DETAIL', '')
          await customerSegmentPresenter.getDetailCustomerSegment(customerSegmentStore, id)
          let name = ''

          if (customerSegmentStore.detailCustomerSegment.isSuccess) {
            name = customerSegmentStore.detailCustomerSegment.data?.customerSegmentName || '';
          }
          newPanes.push({
            // label: `${name}`,
            label: <>
              <Text
                style={{ width: 100, color: "black !important" }}
                ellipsis={{ tooltip: name }
                }
              >
                {name}
              </Text>
            </>,
            children: <CustomerSegmentDetail onMoveTab={removeKey} data={customerSegmentStore.detailCustomerSegment.data} customerSegmentationName={name} customerSegmentationId={tabId as string} />,
            key: newKey,
          });
          setItems(newPanes);
        }
        setActiveKey(newKey);
      }
    };

    const remove = (targetKey: TargetKey) => {
      if (items && items.length > 2) {
        let newActiveKey = activeKey;
        let lastIndex = -1;
        items.forEach((item, i) => {
          if (item.key === targetKey) {
            lastIndex = i - 1;
          }
        });
        const newPanes = items.filter((item) => item.key !== targetKey);
        if (newPanes.length && newActiveKey === targetKey) {
          if (lastIndex >= 0) {
            if (lastIndex > 0) {
              newActiveKey = newPanes[lastIndex].key;
            } else {
              newActiveKey = newPanes[newPanes.length - 1].key;
            }
          } else {
            newActiveKey = newPanes[0].key;
          }
        }
        setItems(newPanes);
        setActiveKey(newActiveKey);
      } else {
        navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.LINK);
      }
    };

    const onEdit = (targetKey: React.MouseEvent | React.KeyboardEvent | string, action: 'add' | 'remove') => {
      if (action === 'add') {
        navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.DETAIL.LINK + `?tabId=${nanoid() + 'CREATE'}`);
      } else {
        remove(targetKey);
      }
    };

    const removeKey = (targetKey: string) => {
      setDeleteKey(targetKey);
    };

    useEffect(() => {
      if (tabId) {
        if (!changeTab) {
          if (tabId?.endsWith('CREATE')) {
            if (checkPermission('CREATE')) addNewTab(tabId);
          } else if (tabId?.endsWith('DETAIL')) {
            addTabDetail();
          }
        }
      } else {
        navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.LINK);
      }
    }, [tabId]);

    useEffect(() => {
      if (deleteKey) {
        remove(deleteKey);
      }
    }, [deleteKey]);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.customer-seg'),
          },
        ]}
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <Tabs
            activeKey={activeKey}
            type={checkPermission('CREATE') ? 'editable-card' : 'card'}
            size={'small'}
            onEdit={onEdit}
            onChange={onChange}
            className={
              'h-full [&_.ant-tabs-tab]:!rounded-t-sm [&_.ant-tabs-tab]:!text-default [&_.ant-tabs-tab]:!font-semibold [&_.ant-tabs-tab:hover]:!text-primary [&_.ant-tabs-tab]:!border-gray-300 [&>.ant-tabs-nav_.ant-tabs-tab]:!bg-gray-200 ' +
              '[&>.ant-tabs-nav_.ant-tabs-tab.ant-tabs-tab-active]:!bg-white [&_.ant-tabs-tab-active]:!border-b-white [&_.ant-tabs-tab-active>div]:!text-primary [&_.ant-tabs-nav]:!mb-0 [&_.ant-tabs-nav::before]:!border-b-gray-300 ' +
              '[&_.ant-tabs-nav-add]:!border [&_.ant-tabs-nav-add]:!border-gray-300 '
            }
            items={items}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
};

export default createDetailCustomerSegment;
